module.exports = __webpack_public_path__ + "img/doctor-stethoscope-violet.46e54352.svg";